<script lang="ts">
  import { EVENT_WINDOW } from '../../game/constants/hud';

  const { label, countdown }: { label: string; countdown: string } = $props();
</script>

<!-- The event window, right-aligned below the leaderboard. Absent entirely when nothing is due. -->
{#if label !== ''}
  <div
    class="event"
    style:right="{EVENT_WINDOW.rightMargin}px"
    style:font-size="{EVENT_WINDOW.font}px"
    role="status"
  >
    <p class="event__line" style:top="{EVENT_WINDOW.labelY}px">{label}</p>
    <p class="event__line" style:top="{EVENT_WINDOW.countdownY}px">{countdown}</p>
  </div>
{/if}

<style>
  .event {
    position: absolute;
    top: 0;
    color: #ee1111;
    text-align: right;
  }

  .event__line {
    position: absolute;
    right: 0;
    margin: 0;
    line-height: 1;
    white-space: nowrap;
    transform: translateY(-0.78em);
  }
</style>
